import { queryOptions } from "@tanstack/react-query";
import {
  acceptInvitationResponseSchema,
  createInvitationResponseSchema,
  createTrialResponseSchema,
  meResponseSchema,
  membersResponseSchema,
  type CreateInvitationRequest,
  type CreateTrialRequest,
  type Membership,
} from "@ortura/shared";
import type { ApiClient } from "./client";

// =============================================================================
// Plattform-Endpunkte (Profil, Onboarding, Einladungen, Mitglieder)
// =============================================================================
// TanStack Query verwaltet Server-Daten im Browser: lädt, cached, lädt neu.
// Ein "Query Key" identifiziert die Daten; nach Änderungen wird der Key
// invalidiert und die Daten neu geholt. queryOptions() bündelt Key und
// Ladefunktion typsicher, damit Router-Loader und Komponenten dasselbe nutzen.

export const queryKeys = {
  me: ["me"] as const,
  members: (tenantId: string) => ["tenant", tenantId, "members"] as const,
};

export function meQuery(api: ApiClient) {
  return queryOptions({
    queryKey: queryKeys.me,
    queryFn: () => api.request({ path: "/me", schema: meResponseSchema }),
  });
}

export function membersQuery(api: ApiClient, tenantId: string) {
  return queryOptions({
    queryKey: queryKeys.members(tenantId),
    queryFn: () =>
      api.request({ path: "/tenant/members", tenantId, schema: membersResponseSchema }),
  });
}

export function createTrial(api: ApiClient, input: CreateTrialRequest) {
  return api.request({
    method: "POST",
    path: "/onboarding/trial",
    body: input,
    schema: createTrialResponseSchema,
  });
}

export function acceptInvitation(api: ApiClient, token: string) {
  return api.request({
    method: "POST",
    path: "/invitations/accept",
    body: { token },
    schema: acceptInvitationResponseSchema,
  });
}

export function createInvitation(api: ApiClient, tenantId: string, input: CreateInvitationRequest) {
  return api.request({
    method: "POST",
    path: "/tenant/invitations",
    tenantId,
    body: input,
    schema: createInvitationResponseSchema,
  });
}

// Mandant zur Pfad-Subdomain (Entscheidung 35). undefined = keine Mitgliedschaft.
export function findMembership(
  memberships: readonly Membership[],
  subdomain: string,
): Membership | undefined {
  return memberships.find((m) => m.subdomain === subdomain);
}
